import css from './audioUpload.module.css'
import { useEffect, useState } from 'react'
import UploadAudioModal from './UploadAudioModal'
import { IAudio, IDraftAudio } from '../../../../types/tasks.types'
import { ReactComponent as PlayIcon } from '../../../../asserts/icons/play.svg'
import { ReactComponent as PauseIcon } from '../../../../asserts/icons/pause.svg'
import audioSrc from '../../../../asserts/icons/audio.png'

interface IProps {
  name?: string
  audio?: IAudio
  onAudio: (audio: IDraftAudio, name?: string) => void
  active?: boolean
}

const AudioUpload = (props: IProps) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const [fileName, setFilename] = useState('')
  const [uploadModalOpen, setUploadModalOpen] = useState(false)

  useEffect(() => {
    if (!isPlaying) return

    const url = props.audio?.file ?? URL.createObjectURL(props.audio as any)
    if (!url) return

    const element = new Audio(url)
    element.addEventListener('ended', () => setIsPlaying(false))
    element.addEventListener('canplaythrough', () => element.play())

    return () => element.pause()
  }, [isPlaying])

  const handleAudio = (audio: File) => {
    if (props.active === false) return

    setUploadModalOpen(false)
    setFilename(audio?.name ?? '')

    if (!audio) props.onAudio(null, props.name)
    else props.onAudio({ rightAnswer: false, type: 'TASK_DESCRIPTION', file: audio }, props.name)
  }

  const togglePlay = (ev) => {
    ev.preventDefault()
    ev.stopPropagation()

    setIsPlaying((prev) => !prev)
  }

  const renderAudioPlayControls = () => {
    if (!props.audio) return

    return !isPlaying ? (
      <PlayIcon onClick={togglePlay} className={css.playPauseIcon} />
    ) : (
      <PauseIcon onClick={togglePlay} className={css.playPauseIcon} />
    )
  }

  const fn = fileName || decodeURI(props.audio?.file?.split('/')?.at(-1) ?? '')
  return (
    <div
      className={css.wrapper}
      data-active={props.active}
      onClick={() => {
        props.active !== false && setUploadModalOpen(true)
      }}
    >
      {uploadModalOpen && (
        <UploadAudioModal
          onClose={() => setUploadModalOpen(false)}
          onAudio={handleAudio}
          audio={props.audio}
          fileName={fn}
          onPlay={() => setIsPlaying(true)}
          onStop={() => setIsPlaying(false)}
          isPlaying={isPlaying}
        />
      )}

      <div className={css.playPauseBlock}>
        {!props.audio && <div className={css.icon} style={{ backgroundImage: `url(${audioSrc})` }} />}
        {renderAudioPlayControls()}
        <span className={css.filename} title={fn}>
          {!props.audio ? 'Аудиофайл не приложен' : fn}
        </span>
      </div>
    </div>
  )
}

export default AudioUpload
